import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import Header from "../HeaderNew/component";
import { ToastContainer } from "react-toastify";
import BackArrow from "../../images/left-arrow.svg";
import "./styles.scss";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import NoData from "../../components/NewImages/no-data.png";
import { notify, handleAddToCart, errorCodeMessages } from "../../components/common/utils";
import {
  updateCartItem,
  setSearchInputValue,
  fetchCatelogues,
  fetchTags
} from "../../slices/catalogSlice";
import Loader from "../../components/common/loader";
import { AddIcon } from "../../components/svgicons";
import ProductCard from "../../components/common/product-card";
import { v4 as uuidv4 } from "uuid";
import { ondcSelect } from "../../slices/ondcPreorderSlice";
import ManageAddress from "../ManageAddress/component";
import Login from "../Login/component";
import { Modal } from "reactstrap";
import MobileAddCart from "../../components/common/mobile-add-cart/index";

let cancelToken;
const MobileSearchResult = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [catalogDataTemp, setCatalogDataTemp] = useState([]);
  const searchedcatalogues = useSelector((s) => s.catalog.searchedcatalogues);
  const searchChips = useSelector((s) => s.catalog.searchChips);
  const searchChipsStatus = useSelector((s) => s.catalog.searchChipsStatus);
  const searchCatalogueStatus = useSelector(
    (s) => s.catalog.searchCatalogueStatus
  );
  const cartItems = useSelector((s) => s.catalog.cartItems);
  const searchInputValue = useSelector((s) => s.catalog.searchInputValue);
  const defaultAddress = JSON.parse(localStorage.getItem("defaultAddress"));
  const defaultLat = parseFloat(defaultAddress?.latitude);
  const defaultLon = parseFloat(defaultAddress?.longitude);
  const [selectedChips, setSelectedChips] = useState([]);
  const bgClasses = ['success', 'pink', 'lightBlue'];

  const [shippingAddress, setShippingAddress] = useState(defaultAddress?.address);
  const [zipcode, setZipcode] = useState("");
  const [selectLoadingId, setSelectLoadingId] = useState("");
  const [selectLoading, setSelectLoading] = useState(false);
  const [cartError, setCartError] = useState("");
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [addressModal, setAddressModal] = useState(false);
  const token = localStorage.getItem("token");

  useEffect(() => {
    catalogs();
  }, [cartItems]);

  useEffect(() => {
    callSearchApi("");
    dispatch(fetchTags());
  }, []);

  useEffect(() => {
    if (searchedcatalogues) {
      catalogs();
    }
  }, [searchedcatalogues]);

  const dispatchOndcSelect = (updatedCartItems, productId, cb = () => { }) => {
    const defaultAddress = JSON.parse(localStorage.getItem("defaultAddress"));
    setSelectLoading(true);
    setSelectLoadingId(productId)
    if (!token) {
      setModalIsOpen(true);
      setSelectLoading(false);
      return;
    }
    if (!defaultAddress?.address?.address_line2) {
      setAddressModal(true);
      setSelectLoading(false);
      return;
    }
    setCartError("");
    const user = JSON.parse(localStorage.getItem("user"));
    const select_transaction_id = JSON.parse(
      localStorage.getItem("transaction_id")
    );
    const items = updatedCartItems?.map((item) => ({
      id: item.catalogData._id,
      quantity: item.quantity,
    }));
    const transaction_id = select_transaction_id
      ? select_transaction_id
      : uuidv4();
    dispatch(
      ondcSelect({
        userAddress: defaultAddress?.address,
        items,
        userId: user?._id,
        transactionId: transaction_id,
        landingSource: localStorage.getItem("landingSource") ? localStorage.getItem("landingSource") : ""
      })
    ).then((response) => {
      localStorage.setItem("transaction_id", JSON.stringify(transaction_id));
      setSelectLoading(false);
      setSelectLoadingId("");
      if (response?.payload?.success && response?.payload?.data && !response?.payload?.data?.error) {
        cb(true)
      }
      else if (response?.payload?.data?.error?.message?.length > 0) {
        cb(false)
        try {
          const errorData = JSON.parse(response?.payload?.data?.error?.message)
          const errorItem = errorData?.find((item) => item?.item_id === productId);
          const errorCode = errorItem?.error;
          let errorMessage = errorCode ? errorCodeMessages(errorCode) || "" : null;
          setCartError(errorMessage);
          if (typeof errorMessage !== "string") {
            errorMessage = "Uh-oh! Seller facing a technical issue";
          }
          notify("error", errorMessage)
        } catch (e) {
          setCartError(response?.payload?.data?.error?.message);
          notify("error", response?.payload?.data?.error?.message)
          return
        }
        const errMsg = response?.payload?.data?.error?.message ? response?.payload?.data?.error?.message : response?.payload?.message;
        const error = errorCodeMessages(response?.payload?.data?.error?.code, errMsg);
        if (!response?.payload?.data?.error?.code) {
          const err_with_id = `${errMsg}`;
          setCartError(err_with_id);
          notify("error", err_with_id)
        }
        else if (response?.payload?.data?.error?.code === "40002") {
          setCartError(error);
          notify("error", error)
        }
        else {
          const err_with_id = `${error}`;
          setCartError(err_with_id);
          notify("error", err_with_id)
        }
      }
      else {
        cb(false)
        notify("error", "Uh-oh! Seller facing a technical issue")
      }
    });
  };



  const handleSellerClick = (data, onPressViewAll) => {
    localStorage.setItem("sellerDetails", JSON.stringify(data));
    if (onPressViewAll) {
      const encodedValue = encodeURIComponent(data?.providerId);
      const url = data?.resultMatchType === "product"
        ? `/seller?pid=${encodedValue}&search=${searchInputValue}`
        : `/seller?pid=${encodedValue}`;
      navigate(url);
    }
  };

  const callSearchApi = async (e) => {
    if (typeof cancelToken != typeof undefined) {
      cancelToken.cancel("Operation canceled due to new request.");
    }
    cancelToken = axios.CancelToken.source();
    const location = `${defaultLat},${defaultLon}`;
    dispatch(
      fetchCatelogues({
        search: e, // e.target?.value,
        location: location,
        areaCode: defaultAddress?.zipcode,
        token: cancelToken.token,
      })
    );
  };
  const handleChipClick = (chipText) => {
    const searchTerms = searchInputValue
      ? searchInputValue.split(",").map((term) => term.trim())
      : [];
    let updatedSearchValue;
    if (searchTerms.includes(chipText)) {
      updatedSearchValue = searchTerms
        .filter((term) => term !== chipText)
        .join(", ");
    } else {
      updatedSearchValue = [...searchTerms, chipText].join(", ");
    }

    dispatch(setSearchInputValue(updatedSearchValue));
    callSearchApi(updatedSearchValue);
    setSelectedChips(updatedSearchValue.split(",").map((term) => term.trim()));
  };

  const updateCartItemQuantity = (itemId, newQuantity, singleCatalogData, addToCart) => {
    const itemIndex = cartItems?.findIndex((item) => item._id === itemId);
    if (newQuantity > parseInt(singleCatalogData?.availableQuantity)) {
      notify(
        "success",
        "Available Quantity is only " + singleCatalogData?.availableQuantity
      );
    } else if (newQuantity > parseInt(singleCatalogData?.maximumQuantity)) {
      notify(
        "success",
        `Maximum quantity available is ${singleCatalogData?.maximumQuantity} for this product`
      );
    } else {
      let updatedCartItems;
      if (itemIndex !== -1) {
        updatedCartItems = cartItems?.map((item, index) =>
          index === itemIndex ? { ...item, quantity: newQuantity } : item
        );
        if (newQuantity === 0) {
          updatedCartItems = updatedCartItems.filter(
            (item) => item._id !== itemId
          );
        }
      } else {
        if (newQuantity !== 0) {
          const newCartItem = {
            _id: singleCatalogData._id,
            productId: singleCatalogData.productId,
            quantity: newQuantity,
            catalogData: singleCatalogData,
          };
          updatedCartItems = [...cartItems, newCartItem];
        } else {
          updatedCartItems = [...cartItems];
        }
      }
      const cartStorage = JSON.parse(localStorage.getItem("cart")) || [];
      const existingProviderId = cartStorage?.[0]?.catalogData?.providerId;
      if (existingProviderId && updatedCartItems?.some(item => item?.catalogData?.providerId !== existingProviderId)) {
        notify("error", "You can add items from a single store at a time.");
      } else {
        if (newQuantity === 1 && addToCart && !existingProviderId) {
          dispatchOndcSelect(updatedCartItems, singleCatalogData?._id, (status) => {
            if (status) {
              handleAddToCart(
                singleCatalogData?.productName,
                singleCatalogData?._id,
                singleCatalogData?.subCategoryId,
                newQuantity,
                singleCatalogData?.price,
                singleCatalogData?.store?.name
              );
              localStorage.setItem("cart", JSON.stringify(updatedCartItems));
              dispatch(updateCartItem(updatedCartItems));
            }
          });
        }
        else {
          handleAddToCart(
            singleCatalogData?.productName,
            singleCatalogData?._id,
            singleCatalogData?.subCategoryId,
            newQuantity,
            singleCatalogData?.price,
            singleCatalogData?.store?.name

          );
          localStorage.setItem("cart", JSON.stringify(updatedCartItems));
          dispatch(updateCartItem(updatedCartItems));
        }
      }
    }
  };

  const catalogs = () => {
    if (!searchedcatalogues) {
      return;
    }
    const updatedSellers = searchedcatalogues?.map((seller) => {
      const updatedCataloguesArr = seller.cataloguesArr.map((catalogue) => {
        const index = cartItems?.findIndex(
          (item) => item._id === catalogue._id
        );
        if (index !== -1) {
          return { ...catalogue, quantity: cartItems[index].quantity };
        } else {
          return { ...catalogue, quantity: 1 }; // Default quantity if not found in cartItems
        }
      });
      return { ...seller, cataloguesArr: updatedCataloguesArr };
    });
    setCatalogDataTemp(updatedSellers);
  };

  const setVariant = (variantId, product) => {
    if (variantId) {
      const singleVariant = product?.variants.find(
        (item) => item?._id === variantId
      );
      if (singleVariant) {
        const updatedSellerData = catalogDataTemp.map((seller) => {
          const updatedCataloguesArr = seller.cataloguesArr.map((catalog) => {
            if (catalog._id === product._id) {
              return {
                ...catalog,
                _id: singleVariant?._id,
                productName: singleVariant?.productName,
                productImages: singleVariant?.productImages,
                weight: singleVariant?.weight,
                weightUnit: singleVariant?.weightUnit,
                price: singleVariant?.price,
                maximumPrice: singleVariant?.maximumPrice,
                description: singleVariant?.description,
                quantity: 1, // or use the existing cart quantity if needed
              };
            }
            return catalog;
          });

          return { ...seller, cataloguesArr: updatedCataloguesArr };
        });

        setCatalogDataTemp(updatedSellerData);
      } else {
        console.error("Variant not found");
      }
    }
  };
  const ProductDetailSliderSettings = {
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1378,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: false,
        },
      },
      {
        breakpoint: 1160,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: false,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: false,
        },
      },
      {
        breakpoint: 580,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  return (
    <>
      <ToastContainer
        autoClose={300}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Header />
      <div className="search-page-container">
        <div className="container">
          <div className="back-title-kl">
            <div
              type="button"
              onClick={() => {
                navigate(-1);
              }}
              href="#"
              className="shopping-title-kl"
            >
              <img
                src={BackArrow}
                style={{ width: "10px", height: "12px" }}
                className="back-arrow"
                alt="back"
              />
              Your Shopping List
            </div>
            {catalogDataTemp?.length > 0 && <div className="total-store-found">
              {`${catalogDataTemp.length} ${catalogDataTemp.length > 1 ? "Stores" : "Store"} Found`}
            </div>}
          </div>
          <p className="multiple-times-title-kl">
            Use "," to add multiple items
          </p>
          {searchChipsStatus === "loaded" && searchChips.length > 0 &&
            <div className="searched-products-kl">
              <h4>Popular Searches</h4>
              <div className="search-product-history">
                {searchChips.map((item) => (
                  <button
                    type="button"
                    className={`search-product-kl ${selectedChips.includes(item) ? "search-product-tag-kl" : ""
                      }`}
                    onClick={() => handleChipClick(item)}
                  >
                    {item} <AddIcon />
                  </button>
                ))}
              </div>
            </div>
          }
        </div>
        <div className="searchstore-flex">
          {searchCatalogueStatus === "loaded" &&
            catalogDataTemp &&
            catalogDataTemp.length > 0 ? (
            catalogDataTemp.map((data, index) => (
              <div className={`search-page-section-kl ${bgClasses[index % bgClasses.length]}`}>
                <div className="container">
                  <div key={index}>
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="section-heading-container-kl">
                          <div className="section-heading-title-kl">{data?.name}</div>
                          <button
                            type="button"
                            className="search-view-all-kl"
                            onClick={() => handleSellerClick(data, true)}
                          >
                            View All
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-12">
                        <Slider {...ProductDetailSliderSettings}>
                          {data?.cataloguesArr?.map((product, productIndex) => (
                            <ProductCard
                              key={productIndex}
                              data={product}
                              catalogDataTemp={catalogDataTemp}
                              navigate={navigate}
                              setVariant={setVariant}
                              updateCartItemQuantity={updateCartItemQuantity}
                              cartItems={cartItems}
                              selectLoading={selectLoading}
                              selectLoadingId={selectLoadingId}
                            />
                          ))}
                        </Slider>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : searchCatalogueStatus === "loading" ? (
            <p className="search-loader">
              <Loader />
            </p>
          ) : searchCatalogueStatus !== "loading" &&
            searchCatalogueStatus !== "loaded" ? (
            <div className="nothing-match">
              <p></p>
            </div>
          ) : (
            <div className="nothing-match">
              <div className="no-cart-img">
                <img alt="NoDataImage" src={NoData} />
              </div>
              <h6 className="text-center">No Stores Found</h6>
            </div>
          )}
        </div>
      </div>
      {modalIsOpen && (
        <Login
          isOpenFromCart={false}
          modalIsOpen={modalIsOpen}
          setModalIsOpen={setModalIsOpen}
        ></Login>
      )}
      <Modal
        isOpen={addressModal}
        size="lg"
        toggle={() => setAddressModal(false)}
        className="custom-modal-kl"
      >
        <div className="addressmodalBlock">
          <ManageAddress
            onAddressSelected={dispatchOndcSelect}
            setZipcode={setZipcode}
            setAddressModal={setAddressModal}
            setShippingAddress={setShippingAddress}
            zipcode={zipcode}
            isInHeader={false}
          />
        </div>
      </Modal>
      <MobileAddCart itemCount={cartItems?.length} />
    </>
  );
};

export default MobileSearchResult;
